const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Pasirinkite čia.",
  seeAll: "Rodyti viską",
  clear: "Išvalyti",
  back: "Atgal",
  save: "Išsaugoti",
  close: "Uždaryti",
  of: "Iš",
  to: "į",
  copyrights: "© {date} Bridgestone Solutions. Visos teisės saugomos.",
  pageNotFound: "Puslapis nerastas",
  accessDenied: "Prieiga uždrausta",
  search: "Ieškoti",
  year: "Metai",
  buttons: {
    loading: "Įkeliama...",
    export: "Eksportuoti",
    delete: "Ištrinti",
    save: "Išsaugoti",
    cancel: "Atšaukti",
    next: "Kitas",
    back: "Atgal",
    skip: "Praleisti",
    send: "Siųsti",
    readNow: "Skaitykite dabar",
    pointsList: "Taškų sąrašas",
    clear: "Išvalyti",
    more: "Di più",
    close: "Uždaryti",
    reportError: "Pranešti apie klaidą",
    accept: "Priimti",
    download: "Atsisiųsti",
    downloadAll: "Atsisiųsti viską",
    selectAll: "Pasirinkti viską",
    deselectAll: "Panaikinti pasirinkimą",
    downloadSelection: "Atsisiųsti pasirinktus",
    dealerInfoDownload: "Atsisiųsti",
    toTheBasket: "Į krepšelį",
    toOrderDelivery: "Tęsti į pristatymo adresą",
    discover: "Atrasti",
    newAddress: "Sukurti naują pristatymo adresą",
    selectAddressBtn: "Pasirinkti pristatymo adresą",
    toOrderSummary: "Į užsakymo apžvalgą",
    placeOrder: "Privalomas užsakymas",
    toDashboard: "Į pradžios puslapį",
    newOrder: "Naujas užsakymas",
    userOrders: "Į jūsų užsakymus",
    toSearch: "Paieška",
    select: "Pasirinkti",
    moreCustomerNumbers: "+ PRIDĖTI DAUGIAU KLIENTŲ NUMERIŲ",
    loadMore: "Įkelti daugiau",
    toStaffDashboard: "Į skydelį",
    toQuiz: "Į testą",
    vouchers: "Kuponai",
    exchangeVoucher: "Išpirkti kupono kodą",
    confirm: "Patvirtinti",
    sharePoints: "Dalintis taškais",
    create: "Sukurti",
    update: "Atnaujinti",
    toBDrive: "Į B-Drive",
    preview: "Peržiūra",
    clickHere: "Peržiūrėti detales",
    setFilters: "Nustatykite <b>ne daugiau kaip vieną filtrą kiekvienam stulpeliui</b>",
    all: "Visi",
  },
  tooltips: {
    info: "Reikia pagalbos? +371 26 12 67 71",
  },
  confirmation: {
    header: "Reikalingas patvirtinimas",
    message: "Ar tikrai norite ištrinti šį įrašą?",
  },
  nav: {
    consents: "Sutikimai",
    dashboard: "Pagrindinis",
    accountDashboard: "Skydelis",
    account: "Mano Profilis",
    mailbox: "Pašto dėžutė",
    singleMailbox: "Žinutės",
    stammdaten: "Pagrindiniai duomenys",
    news_feeds: "Naujienos",
    pointsOverview: "Taškų apžvalga",
    rewardsOverview: "Taškų apžvalga",
    about: "Apie BS Plus",
    service_number: "Susisiekti su aptarnavimu",
    shop: "Apdovanojimų parduotuvė",
    salesPromotions: "Pardavimo akcijos",
    promotions: "Mano paskyra",
    shopCategory: "Apdovanojimų parduotuvė",
    productDetails: "Produkto informacija",
    userOrders: "Naudotojo užsakymai",
    shoppingCart: "Pirkinių krepšelis",
    orderDelivery: "Pristatymo adresas",
    orderSummary: "Užsakymo apžvalga",
    orderComplete: "Užsakymas baigtas",
    text_page: "Statinis puslapis",
    staff: "Aptarnavimo skydelis",
    onlineTrainings: "Internetiniai mokymai",
    trainings: "Mokymai",
    training: "Mokymas",
    trainingForm: "Mokymų forma",
    staffVouchers: "Kuponai",
    wholesalerVouchers: "Kuponai",
    brochure_prices: "Kainoraščiai ir brošiūros",
    investment: "Investiciju parama",
    media: "Medija",
    medias: "Medija",
    contact_service: "Kontaktai ir aptarnavimas",
    productInfo: "PRODUKTO INFORMACIJA",
    bDrive: "Produktų nuotraukos",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Dalyvavimo sąlygos",
    first_stop: "Bridgestone padangų garantija",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Pagrindinis",
    accountDashboard: "Skydelis",
    account: "Mano Profilis",
    mailbox: "Pašto dėžutė",
    singleMailbox: "Žinutės",
    stammdaten: "Pagrindiniai duomenys",
    news_feeds: "Naujienos",
    pointsOverview: "Taškų apžvalga",
    rewardsOverview: "Taškų apžvalga",
    about: "Apie BS Plus",
    service_number: "Susisiekti su aptarnavimu",
    shop: "Apdovanojimų parduotuvė",
    salesPromotions: "Pardavimo akcijos",
    promotions: "Mano paskyra",
    shopCategory: "Apdovanojimų parduotuvė",
    productDetails: "Produkto informacija",
    userOrders: "Naudotojo užsakymai",
    shoppingCart: "Pirkinių krepšelis",
    orderDelivery: "Pristatymo adresas",
    orderSummary: "Užsakymo apžvalga",
    orderComplete: "Užsakymas baigtas",
    staff: "Aptarnavimo skydelis",
    onlineTrainings: "Internetiniai mokymai",
    trainings: "Mokymai",
    training: "Mokymas",
    trainingForm: "Mokymų forma",
    staffVouchers: "Kuponai",
    wholesalerVouchers: "Kuponai",
    brochure_prices: "Kainoraščiai ir brošiūros",
    investment: "Investiciju parama",
    media: "Medija",
    medias: "Medija",
    contact_service: "Kontaktai ir aptarnavimas",
    productInfo: "PRODUKTO INFORMACIJA",
    bDrive: "Produktų nuotraukos",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Dalyvavimo sąlygos",
    first_stop: "Bridgestone padangų garantija",
    payouts: "Payouts",
},
  menu: {
    account: "Mano Profilis",
    plus: 'Apie Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Pardavimo palaikymas",
    mailbox: "Pašto dėžutė",
    about: "Apie BS Plus",
    trainingAndCourses: "Mokymai ir kursai",
    externalTraining: "Išoriniai mokymai",
    productInfo: "Produkto informacija",
    productBrochures: "Produktų brošiūros",
    priceLists: "Kainoraščiai",
    price: "Kaina",
    complaintForm: "Skundų forma",
    sales_support: "Pardavimo palaikymas",
    contact_service: "Kontaktai ir aptarnavimas",
    logOut: "Atsijungti",
    news: "Naujienos",
    news_feeds: "Naujienos",
    service_number: "Susisiekti su aptarnavimu",
    salesPromotions: "Pardavimo akcijos",
    shop: "Parduotuvė",
    onlineTrainings: "Internetiniai mokymai",
    trainings: "Mokymai",
    brochure_prices: "Kainoraščiai ir brošiūros",
    media: "Medija",
    medias: "Medija",
    stammdaten: "Pagrindiniai duomenys",
    preislisten: "Kainoraščiai",
  },
  validation: {
    requiredField: "Campo obbligatorio",
  },
  sortBy: {
    default: "Rūšiuoti pagal",
    desc: "Rūšiuoti pagal: Naujausi",
    asc: "Rūšiuoti pagal: Seniausi",
    name: "Pavadinimas",
    date: "Data",
    choiceBy: "Rūšiuoti",
  },
  month: {
    1: "sausis",
    2: "vasaris",
    3: "kovas",
    4: "balandis",
    5: "gegužė",
    6: "birželis",
    7: "liepa",
    8: "rugpjūtis",
    9: "rugsėjis",
    10: "spalis",
    11: "lapkritis",
    12: "gruodis"
  },
};


export default {
  messages,
};
